<div class="modal-fundo" *ngIf="mostrarModal">
    <div class="modal-conteudo">
        <div class="modal-cabecalho">
            <h3 class="modal-titulo">Gestão do Usuário</h3>
            <button class="modal-fechar" (click)="fechar()" [disabled]="salvandoPermissoes">&times;</button>
        </div>
        <div class="modal-corpo">            
            <div class="form-row">
                <input type="text" value="{{usuario?.nome ?? '-'}}" disabled>
                <input type="email" value="{{usuario?.email ?? '-'}}" disabled>
            </div>

            <div class="secao-titulo">
                <span>Gestão de Acessos</span>
                <div class="limite-container" *ngIf="permissaoService.hasPermission(EnumPermissao.CriarNovosUsuarios)">
                    <span>Limite de Contatos</span>
                    <app-carregando [showCarregando]="carregandoPermissoes" [isChart]="false" spinnerSize="18px"></app-carregando>
                    <input 
                        [(ngModel)]="limiteContatosExibicao"
                        type="text" 
                        class="limite-input" 
                        placeholder="Preencher a quantidade de contatos" 
                        *ngIf="!carregandoPermissoes"
                        (input)="onChangeLimiteContatos($event)"
                    >
                </div>
            </div>

            <div class="separador"></div>

            <app-carregando [showCarregando]="carregandoPermissoes" [isChart]="false" containerHeight="20vh" spinnerSize="40px">
            </app-carregando>
            <div class="opcoes-container" *ngIf="!carregandoPermissoes">                
                <div class="opcao-item" *ngFor="let permissao of todasPermissoes">
                    <label class="toggle">
                        <input 
                            type="checkbox" 
                            [checked]="temPermissao(permissao.idPermissao) || usuarioEditadoEhMaster" 
                            [disabled]="usuarioEditadoEhMaster" 
                            value="{{permissao.idPermissao}}"
                            >
                        <span class="slider" [class.slider-disabled]="usuarioEditadoEhMaster"></span>
                    </label>
                    <span class="opcao-texto">{{permissao.descricao}}</span>
                </div>
            </div>
        </div>
        <div class="modal-rodape">
            <div class="rodape-container">
                <span [style.visibility]="usuarioEditadoEhMaster ? 'visible' : 'hidden'" class="texto-aviso">
                    * Um usuário master não pode ter permissões editadas
                </span>
                <div class="botoes">
                    <button class="btn-cancelar" (click)="fechar()" [disabled]="salvandoPermissoes">Cancelar</button>
                    <button 
                        class="btn-salvar" 
                        (click)="salvarPermissoesUsuario()"
                        [disabled]="salvandoPermissoes || carregandoPermissoes"
                    >
                        <span *ngIf="!salvandoPermissoes">Salvar usuário</span>
                        <span *ngIf="salvandoPermissoes">Salvando...</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>